import { useT } from "@/lib/i18n";
import { fmtLap } from "@/lib/laps";

const Stat = ({ label, value, sub, accent = "text-white", testid }) => (
  <div data-testid={testid} className="bg-[#12141C] border border-[#282D3D] rounded-sm p-4">
    <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{label}</div>
    <div className={`font-mono font-bold text-2xl sm:text-3xl leading-tight mt-1 ${accent}`}>{value}</div>
    {sub && <div className="font-mono text-xs text-slate-500 mt-1">{sub}</div>}
  </div>
);

export const LapMeta = ({ meta, prefix = "lap" }) => {
  const entries = Object.entries(meta || {}).filter(([, v]) => v);
  if (!entries.length) return null;
  return (
    <div data-testid={`${prefix}-meta`} className="flex flex-wrap gap-1.5">
      {entries.map(([k, v]) => (
        <span key={k} className="font-mono text-xs border border-[#282D3D] bg-[#090A0F] rounded-sm px-2 py-1">
          <span className="text-slate-500 uppercase text-[10px] mr-1.5">{k}</span>{v}
        </span>
      ))}
    </div>
  );
};

export const LapStats = ({ data, stats, prefix = "lap" }) => {
  const { t } = useT();
  const p = data.precision;
  const gap = stats.theoretical != null ? stats.best.time - stats.theoretical : null;
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
        <Stat testid={`${prefix}-stat-best`} label={t("best_lap")} value={fmtLap(stats.best.time, p)} sub={`${t("lap_col")} ${stats.best.lap}`} accent="text-[#10B981]" />
        <Stat testid={`${prefix}-stat-theoretical`} label={t("theoretical")} value={fmtLap(stats.theoretical, p)} sub={gap != null ? `−${gap.toFixed(p)} vs best` : null} accent="text-[#A855F7]" />
        <Stat testid={`${prefix}-stat-average`} label={t("average")} value={fmtLap(stats.avg, p)} sub={`${stats.useful.length} ${t("laps_short")} ≤107%`} />
        <Stat testid={`${prefix}-stat-consistency`} label={t("consistency")} value={`±${stats.std.toFixed(p + 1)}`} sub="s" accent="text-[#FFB800]" />
        <Stat testid={`${prefix}-stat-valid`} label={t("valid_laps")} value={`${stats.valid.length}/${data.laps.length}`} />
      </div>
      {data.param_names.length > 0 && (
        <div data-testid={`${prefix}-maxes`} className="flex flex-wrap gap-2">
          {data.param_names.map((n) => (
            <span key={n} className="font-mono text-xs border border-[#282D3D] bg-[#12141C] rounded-sm px-3 py-1.5">
              <span className="text-slate-500 uppercase text-[10px] mr-2">{n}</span><b className="text-white">{stats.maxes[n] ?? "—"}</b>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
